import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import loginImage from "../../assets/images/login.png";
import LogoWhite from "../../assets/images/LogoWhite.svg";
import infocircle from "../../assets/images/infocircle.svg";
import PrimecareLogo from "../../assets/images/PrimecareLogo.svg";
import { useCommonMessage } from "../../common/CommonMessage";

const LoginNumberListing = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const messageApi = useCommonMessage();
    const location = useLocation();
    const multipleMembers = useMemo(
        () => location?.state?.multipleMembers || [],
        [location?.state?.multipleMembers],
    );
    const loginContext = location?.state?.loginContext;

    const [selectedMemberIndex, setSelectedMemberIndex] = useState(null);

    useEffect(() => {
        if (!multipleMembers?.length || !loginContext?.ssn || !loginContext?.dob) {
            navigate("/guest-user/open-enrollment", { replace: true });
        }
    }, [multipleMembers, loginContext, navigate]);


    const handleContinue = () => {
        const selectedNumber = selectedMemberIndex !== null
            ? multipleMembers[selectedMemberIndex]
            : null;
        if (!selectedNumber) {
            messageApi.open({
                type: "error",
                content: t("Please select a phone number to continue."),
            });
            return;
        }
        navigate("/guest-user/verify-phone-number", {
            state: { selectedNumber, loginContext },
        });
    };

    const navigateToSupportRequest = () => {
        navigate("/support-request");
    };

    return (
        <div className="loginFlex pc">
            <div className="w-50 h-100 position-relative mobileHide">
                <img src={loginImage} alt="" className="w-100 h-100 object-cover" />
                <img src={LogoWhite} alt="" className="loginLogo" />
                <div className="loginText">
                    <h2 className="fs-32 text-white fw-700">
                        {t("Prime Care")}{" "}
                        <span className="fs-28 text-white fw-300 gbo">
                            {t("Provides")}  {t("Nationwide")} <br />{" "}
                            {t("Direct Primary Care")}
                        </span>
                    </h2>
                </div>
            </div>
            <div className="d-flex align-center justify-center w-lg-50 loginside">
                <div className="mx-420 mx-auto">
                    <div className="text-center mb-40 mobileShow">
                        <img src={PrimecareLogo} alt="" />
                    </div>

                    <h1 className="fs-36 mb-8 text-lg-center tgb">{t("Login")}</h1>
                    <h2 className="fs-28 mb-40 text-lg-center tgb">
                        {t("to complete the Education")}
                    </h2>

                    <div className="mb-40 flex gap-10">
                        <div
                            className="fs-14 fw-500 gap-4 lineheight-18 d-flex  mb-20" style={{color: "#8697B1"}}
                        >
                            <img src={infocircle} alt="" className="img15"/>
                            {t("We've found matching records. Select a phone number to continue.")}
                        </div>

                        <h2 className="fs-16 mb-10 fw-500">{t("Select your phone number")}</h2>
                        <div
                            style={{
                                background: "#ffffff",
                                border: "0.5px solid #ccc",
                                borderRadius: "8px",
                            }}
                            className="mb-40 NumberListingScroll"
                        >
                            {multipleMembers.map((number, index) => (
                                <label
                                    key={`${number}-${index}`}
                                    className="custom-radio"
                                    style={{
                                        margin: 0,
                                        padding: "16px",
                                        borderBottom: index !== multipleMembers.length - 1 ? "0.5px solid #ccc" : "none",
                                        gap: "16px",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span className="fs-14" style={{ color: "#162C4E" }}>
                                        {number}
                                    </span>
                                    <input
                                        type="radio"
                                        name="selectedPhone"
                                        checked={selectedMemberIndex === index}
                                        onChange={() => setSelectedMemberIndex(index)}
                                    />
                                    <span className="radio-checkmark" />
                                </label>
                            ))}
                        </div>

                        <button
                            className={`primaryButton w-100 mb-20 cursor-pointer fs-18 ${selectedMemberIndex === null ? "disable" : "cursor-pointer"}`}
                            type="button"
                            onClick={handleContinue}
                            disabled={selectedMemberIndex === null}
                        >
                            {t("Continue")}
                        </button>
                    </div>

                    <div className="text-center mb-40">
                        {t("Already a member?")}{" "}
                        <span onClick={() => navigate("/login")} className="primaryColor cursor-pointer underline">
                            {t("Login")}
                        </span>
                    </div>

                    {/* <div className="mb-30 text-lg-center text-center">
                        {t("By Signing in you agree to our")}{" "}
                        <span
                            className="gm cursor-pointer"
                            onClick={() =>
                                window.open(
                                    "https://primecaregs.com/notice-of-privacy-practices-for-primecare/",
                                    "_blank",
                                )
                            }
                        >
                            {t("Privacy Policy")}
                        </span>
                    </div>
                    <div
                        className="text-center text-underline text-underline cursor-pointer"
                        onClick={navigateToSupportRequest}
                    >
                        {t("Having trouble signing in?")}
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default LoginNumberListing;